export function logSceneEvent(sceneKey: string): void {
  if (typeof window === 'undefined') return;
  const w = window as unknown as {
    __sceneEvents?: Array<{ ts: number; scene: string }>;
    __currentScene?: string;
  };

  if (!w.__sceneEvents) {
    w.__sceneEvents = [];
  }

  w.__currentScene = sceneKey;
  w.__sceneEvents.push({ ts: performance.now(), scene: sceneKey });
}
